import React, { useMemo } from 'react';
import { Input, InputGroup, InputRightElement, Spinner } from '@chakra-ui/react';
import { SearchIcon } from 'src/utils/icons/search';
import { t } from 'i18next';
import { ICustomStyle } from '../App/Wrapper/Wrapper';
import { contrastColors } from '../../utils/parser';
import { Color } from 'src/theme/color';

export const ExplorerInput = ({
	handleChangeInput,
	autoFocus,
	isLoading,
	value,
	customStyle,
	handleBringUpSearch = () => {},
	isVariantCompact = false,
}: {
	autoFocus?: boolean;
	handleChangeInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
	isLoading: boolean;
	value: string;
	handleBringUpSearch?: () => void;
	isVariantCompact?: boolean;
} & ICustomStyle) => {
	enum Variant {
		DEFAULT,
		COMPACT,
	}

	const handleSearchEvent = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			handleBringUpSearch();
		}
	};

	const actionTextColor = useMemo(() => {
		if (!customStyle) {
			return 'white';
		}

		return contrastColors(customStyle.cta!, '#ffffff') > 3.1 ? 'black' : 'white';
	}, [customStyle]);

	const buttonTypeOptions: any = {
		[Variant.DEFAULT]: () => (
			<SearchButton
				isLoading={isLoading}
				handleBringUpSearch={handleBringUpSearch}
				background={customStyle?.cta ?? Color.ACTION}
				color={actionTextColor}
			/>
		),
		[Variant.COMPACT]: () => (
			<SearchButton
				isLoading={isLoading}
				handleBringUpSearch={handleBringUpSearch}
				background={customStyle?.cta ?? Color.ACTION}
				color={actionTextColor}
				width="60px"
				height="60px"
			/>
		),
	};

	const connectButtonType: any = useMemo(() => {
		if (isVariantCompact) {
			return Variant.COMPACT;
		}
		if (!isVariantCompact) {
			return Variant.DEFAULT;
		}
	}, [isVariantCompact]);

	return (
		<InputGroup
			size="lg"
			maxWidth={'350px'}
		>
			<Input
				variant="outlined"
				bg={customStyle?.bg ?? '#1111114D'}
				autoFocus={autoFocus}
				padding={!isVariantCompact ? '18px 24px' : '24px 16px'}
				fontSize={!isVariantCompact ? '12px' : '16px'}
				border={`1px solid ${customStyle ? `${customStyle.cta}40` : '#4E4F52'}`}
				borderRadius="5px"
				onChange={handleChangeInput}
				onKeyPress={handleSearchEvent}
				_focus={{ boxShadow: 'none' }}
				placeholder={t('default.whatYouLooking').toString()}
				_placeholder={{ color: customStyle ? `${customStyle.text}80` : '#A9A9A9' }}
				color={customStyle?.text ?? 'textAction'}
				value={value}
				height={!isVariantCompact ? '48px' : '60px'}
			/>
			{buttonTypeOptions[connectButtonType]()}
		</InputGroup>
	);
};

const SearchButton = ({
	isLoading,
	handleBringUpSearch,
	color,
	...props
}: { isLoading: boolean; handleBringUpSearch: () => void; color: string } | any) => (
	<InputRightElement
		borderRightRadius="5px"
		border={`1px solid ${Color.ACTION}`}
		background={Color.ACTION}
		padding="16px"
		onClick={handleBringUpSearch}
		cursor="pointer"
		{...props}
	>
		{isLoading ? (
			<Spinner
				maxW="18px"
				maxH="18px"
				color={color}
			/>
		) : (
			<SearchIcon color={color} />
		)}
	</InputRightElement>
);
